import { getHtmlLanguageFromShopLocale } from '../utils/meta'

export default defineNuxtPlugin((nuxtApp) => {
  if (!import.meta.server) {
    return
  }

  const currentShop = useCurrentShop()

  const lang = getHtmlLanguageFromShopLocale(currentShop.value?.locale)

  if (!lang) {
    return
  }

  nuxtApp.hook('vue:setup', () => {
    useHead({
      htmlAttrs: {
        lang,
      },
    })
  })
})
